import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const createCancellation = async (bookingId: string, options: Options = {}): Promise<SelfServiceAPI.CreateCancellation.Response> => {
  try {
    const { data } = await axios.post<SelfServiceAPI.CreateCancellation.Response>(
      `${SELF_SERVICE_API_URL}/bookings/${bookingId}/cancellations`,
      undefined,
      {
        withCredentials: true,
      },
    );

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await createCancellation(bookingId, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/cancellations`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createCancellation;
